import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  list: {
    borderBottom: `${theme.spacing(0.125)} solid ${theme.palette.neutral.light}`,
  },
  tab: {
    '& .MuiTab-wrapper': {
      borderRight: `${theme.spacing(0.125)} solid ${theme.palette.neutral.main}`,
      paddingRight: theme.spacing(1.5),
    },
    paddingRight: '0',
  },
  panel: {
    padding: '0',
  },
}));

export default useStyles;
